/**
 * Product Side Panels Manager - Moon Moon Agency
 * Gere l'ouverture/fermeture des side panels du produit :
 *   - Couleur ([data-panel="color"])
 *   - Magasin ([data-panel="store"])
 *   - Guide des tailles ([data-panel="size-guide"])
 *
 * Pattern drawer slide-right, focus trap, Esc, exclusion mutuelle.
 * Triggers : [data-panel-open="<name>"] ; close : [data-panel-close].
 */

/*********************************************************************************************
 * 🎚️ PRODUCT SIDE PANELS MANAGER
 */
const ProductPanelsManager = {
	config: {
		selectors: {
			panel:      '[data-panel]',
			open:       '[data-panel-open]',
			close:      '[data-panel-close]',
			focusable:  'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
		},
		classes: {
			open: 'is-open',
		},
	},

	state: {
		ready: false,
		openName: null,
		triggerEl: null,
		keyHandler: null,
		backdrop: null,
	},

	init() {
		this._ensureBackdrop();
		this._bindEvents();
		this.state.ready = true;
		window.log('info', '🎚️ [PRODUCT_PANELS]', 'Initialized');
	},

	_ensureBackdrop() {
		let backdrop = document.querySelector('.mm-side-panel-backdrop');
		if (!backdrop) {
			backdrop = document.createElement('div');
			backdrop.className = 'mm-side-panel-backdrop';
			backdrop.setAttribute('data-panel-backdrop', '');
			backdrop.setAttribute('aria-hidden', 'true');
			backdrop.hidden = true;
			document.body.appendChild(backdrop);
		}
		this.state.backdrop = backdrop;
	},

	_bindEvents() {
		document.addEventListener('click', (e) => {
			const opener = e.target.closest(this.config.selectors.open);
			if (opener) {
				e.preventDefault();
				this.open(opener.dataset.panelOpen, opener);
				return;
			}
			const closer = e.target.closest(this.config.selectors.close);
			if (closer) {
				e.preventDefault();
				this.close();
				return;
			}
			if (e.target === this.state.backdrop) {
				this.close();
			}
		});
	},

	open(name, triggerEl) {
		if (!name) return;
		const panel = document.querySelector(`[data-panel="${name}"]`);
		if (!panel) {
			window.log('warn', '🎚️ [PRODUCT_PANELS]', `Panel "${name}" not found`);
			return;
		}
		if (this.state.openName) this.close();

		this.state.openName = name;
		this.state.triggerEl = triggerEl || null;

		panel.hidden = false;
		if (this.state.backdrop) {
			this.state.backdrop.hidden = false;
			void this.state.backdrop.offsetWidth;
			this.state.backdrop.classList.add(this.config.classes.open);
		}
		void panel.offsetWidth;
		panel.classList.add(this.config.classes.open);
		panel.setAttribute('aria-hidden', 'false');
		document.documentElement.classList.add('stop-scrolling');

		if (triggerEl) triggerEl.setAttribute('aria-expanded', 'true');

		this.state.keyHandler = (ev) => {
			if (ev.key === 'Escape') {
				ev.preventDefault();
				this.close();
			}
		};
		document.addEventListener('keydown', this.state.keyHandler);

		setTimeout(() => {
			const first = panel.querySelector(this.config.selectors.focusable);
			first?.focus?.();
		}, 100);

		window.emit('global:product-panel-opened', { name });
	},

	close() {
		if (!this.state.openName) return;
		const panel = document.querySelector(`[data-panel="${this.state.openName}"]`);
		if (panel) {
			panel.classList.remove(this.config.classes.open);
			panel.setAttribute('aria-hidden', 'true');
			setTimeout(() => {
				if (this.state.openName !== panel.dataset.panel) {
					panel.hidden = true;
				}
			}, 350);
		}
		if (this.state.backdrop) {
			this.state.backdrop.classList.remove(this.config.classes.open);
			setTimeout(() => {
				if (!this.state.openName) this.state.backdrop.hidden = true;
			}, 350);
		}
		if (this.state.keyHandler) {
			document.removeEventListener('keydown', this.state.keyHandler);
			this.state.keyHandler = null;
		}
		if (this.state.triggerEl) {
			this.state.triggerEl.setAttribute('aria-expanded', 'false');
			this.state.triggerEl.focus?.();
		}
		document.documentElement.classList.remove('stop-scrolling');
		const name = this.state.openName;
		this.state.openName = null;
		this.state.triggerEl = null;
		window.emit('global:product-panel-closed', { name });
	},
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => ProductPanelsManager.init());
} else {
	ProductPanelsManager.init();
}

window.MMProductPanels = ProductPanelsManager;
